<template>
    <div class="p-2">
        <h1 class="font-weight-bolder border-bottom pb-50">Filtrele</h1>
        <div class="row">
            <div class="col-12 mb-1">
                <label class="form-label">Plaka</label>
                <input type="text" placeholder="Plaka" class="form-control" v-model="filter.Plate" />
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Hareket Durumu</label>
                <select class="form-control" v-model="filter.IsVehicleRunning">
                    <option :value="null">Tümü</option>
                    <option :value="true">Yolda</option>
                    <option :value="false">Duruyor</option>
                </select>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Garaj</label>
                <v-select-list :options="garages" label="GarageName" placeholder="Garaj" v-model="garage"></v-select-list>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Görev Firması</label>
                <v-select-list v-model="dutyFirm" :options="firms" label="Name" v-on:input="getLocations" v-on:search="searchFirms" placeholder="Görev Firması" :loading="firmsLoading" img="Logo"></v-select-list>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Görev Firması Lokasyonu</label>
                <v-select-list v-model="location" :options="locations" label="LocationName" placeholder="Görev Firması Lokasyonu" :disabled="dutyFirm == null"></v-select-list>
            </div>
            <div class="col-6">
                <button class="btn btn-secondary w-100" v-on:click="setFilter">Filtrele</button>
            </div>
            <div class="col-6">
                <button class="btn btn-dark w-100" v-on:click="clearFilter">Temizle</button>
            </div>
        </div>
    </div>
</template>

<script>
import VehicleOperationsApi from '@/api/vehicle-operations'
import FirmOperationsApi from '@/api/firm-operations'
export default {
    data(){
        return{
            garages:[],
            firms:[],
            firmsLoading:false,
            locations:[],
            filter:{
                GarageId:null,
                DutyFirmId:null,
                DutyFirmLocationId:null,
                IsVehicleRunning:null,
                Plate:null
            }
        }
    },
    mounted(){
        this.getGarages()
    },
    methods:{
        getGarages(){
            VehicleOperationsApi.Garage.List().then(res=>{
                this.garages = res.data.Data
            })
        },
        searchFirms(search){
            if(search){
                this.firmsLoading = true
                FirmOperationsApi.List(search)
                .then(res=>{
                    this.firms = res.data.Data
                    this.firmsLoading = false
                }).catch(err=>{ this.firmsLoading = false })
            }
        },
        getLocations(){
            if(this.dutyFirm?.Id){
                FirmOperationsApi.Location.List(this.dutyFirm?.Id).then(res=>{
                    this.locations = res.data.Data
                })
            }
        },
        clearFilter(){
            this.filter.GarageId = null
            this.filter.DutyFirmId = null
            this.filter.DutyFirmLocationId = null
            this.filter.IsVehicleRunning = null
            this.filter.Plate = null
            this.$emit("filter",this.filter)
        },
        setFilter(){
            this.$emit("filter",this.filter)
        }
    },
    computed:{
        garage:{
            get:function(){
                return this.garages.find(b=>b.Id==this.filter.GarageId)
            },
            set:function(value){
                this.filter.GarageId = value?.Id || null
            }
        },
        dutyFirm:{
            get:function(){
                return this.firms.find(b=>b.Id==this.filter.DutyFirmId)
            },
            set:function(value){
                this.filter.DutyFirmId = value?.Id || null
            }
        },
        location:{
            get:function(){
                return this.locations.find(b=>b.Id==this.filter.DutyFirmLocationId)
            },
            set:function(value){
                this.filter.DutyFirmLocationId = value?.Id || null
            }
        }
    }
}
</script>

<style>

</style>